import type {ReactElement} from 'react';
import {SkeletonBrick} from '@Components/skeleton-brick';
import {IMAGE_ACTION_SKELETON_HEIGHT, INLINE_SKELETON_WIDTH, OVERFLOW_SKELETON_WIDTH} from '../../image-actions.types';
import type {ImageActionsSkeletonRowProps} from './image-actions-skeleton-row.types';

export function ImageActionsSkeletonRow({inlineCount, hasOverflow}: ImageActionsSkeletonRowProps): ReactElement {
  const getOverflowSkeleton = (): ReactElement | null => {
    if (!hasOverflow) {
      return null;
    }

    return <SkeletonBrick width={OVERFLOW_SKELETON_WIDTH} height={IMAGE_ACTION_SKELETON_HEIGHT} className="radius-8" />;
  };

  return (
    <>
      {Array.from({length: inlineCount}).map((_unused, index): ReactElement => {
        return <SkeletonBrick key={index} width={INLINE_SKELETON_WIDTH} height={IMAGE_ACTION_SKELETON_HEIGHT} className="radius-8" />;
      })}
      {getOverflowSkeleton()}
    </>
  );
}
